<ng-template #btnTpl let-i let-child="child">
  @if (i.tooltip) {
    <span nz-tooltip [nzTooltipTitle]="i.tooltip" [class.d-block]="child" [class.width-100]="child">
      <ng-template [ngTemplateOutlet]="btnItemTpl" [ngTemplateOutletContext]="{ $implicit: i }" />
    </span>
  } @else {
    <ng-template [ngTemplateOutlet]="btnItemTpl" [ngTemplateOutletContext]="{ $implicit: i }" />
  }
</ng-template>
<ng-template #btnItemTpl let-i>
  @if (i.pop) {
    @let pop = i.pop;
    <a
      nz-popconfirm
      [nzPopconfirmTitle]="pop.title"
      [nzIcon]="pop.icon"
      [nzCondition]="pop.condition(i)"
      [nzCancelText]="pop.cancelText"
      [nzOkText]="pop.okText"
      [nzOkType]="pop.okType"
      (nzOnConfirm)="_btn(i)"
      class="st__btn-text"
      [class]="i._className"
      (click)="_stopPropagation($event)"
    >
      <ng-template [ngTemplateOutlet]="btnTextTpl" [ngTemplateOutletContext]="{ $implicit: i }" />
    </a>
  } @else {
    <a (click)="_btn(i, $event)" class="st__btn-text" [class]="i._className">
      <ng-template [ngTemplateOutlet]="btnTextTpl" [ngTemplateOutletContext]="{ $implicit: i }" />
    </a>
  }
</ng-template>
<ng-template #btnTextTpl let-i>
  @if (i._icon) {
    @let icon = i._icon;
    @if (icon.iconfont) {
      <nz-icon [nzIconfont]="icon.iconfont" />
    } @else {
      <nz-icon [nzType]="icon.type" [nzTheme]="icon.theme" [nzSpin]="icon.spin" [nzTwotoneColor]="icon.twoToneColor" />
    }
  }
  <span [innerHTML]="i._text" [class.pl-xs]="i._icon"></span>
</ng-template>
@if (c.__render) {
  <ng-template [ngTemplateOutlet]="c.__render!" [ngTemplateOutletContext]="{ $implicit: i, index: index, column: c }" />
} @else {
  @let col = i._values[cIdx];
  @switch (c.type) {
    @case ('checkbox') {
      <label nz-checkbox [nzDisabled]="i.disabled" [ngModel]="i.checked" (ngModelChange)="_checkbox($event)"></label>
    }
    @case ('radio') {
      <label nz-radio [nzDisabled]="i.disabled" [ngModel]="i.checked" (ngModelChange)="_radio()"></label>
    }
    @case ('link') {
      <a (click)="_link($event)" [innerHTML]="col._text" [attr.title]="col.text"></a>
    }
    @case ('tag') {
      <nz-tag [nzColor]="col.color" [nz-tooltip]="col.tooltip">
        <span [innerHTML]="col._text"></span>
      </nz-tag>
    }
    @case ('badge') {
      <nz-badge [nzStatus]="col.color" [nzText]="col.text" [nz-tooltip]="col.tooltip" />
    }
    @case ('cell') {
      <cell [value]="col.text" [options]="col.cell ?? c.cell" (click)="_client()" />
    }
    @case ('widget') {
      <ng-template st-widget-host [record]="i" [column]="c" />
    }
    @default {
      @if (c.safeType === 'text') {
        <span [innerText]="col._text" [attr.title]="c._isTruncate ? col.text : null"></span>
      } @else {
        <span [innerHTML]="col._text" [attr.title]="c._isTruncate ? col.text : null"></span>
      }
    }
  }
  @for (btn of col.buttons; track $index) {
    @if (btn.children!.length > 0) {
      <a nz-dropdown [nzDropdownMenu]="btnMenu" nzOverlayClassName="st__btn-sub">
        <span [innerHTML]="btn._text"></span>
        <nz-icon nzType="down" />
      </a>
      <nz-dropdown-menu #btnMenu="nzDropdownMenu">
        <ul nz-menu>
          @for (subBtn of btn.children; track $index) {
            @if (subBtn.type === 'divider') {
              <li nz-menu-divider></li>
            } @else {
              <li nz-menu-item [class.st__btn-disabled]="subBtn._disabled">
                <ng-template
                  [ngTemplateOutlet]="btnTpl"
                  [ngTemplateOutletContext]="{ $implicit: subBtn, child: true }"
                />
              </li>
            }
          }
        </ul>
      </nz-dropdown-menu>
    } @else {
      <span [class.st__btn-disabled]="btn._disabled">
        <ng-template [ngTemplateOutlet]="btnTpl" [ngTemplateOutletContext]="{ $implicit: btn, child: false }" />
      </span>
    }
    @if (!$last) {
      <nz-divider nzType="vertical" />
    }
  }
}
